<script setup lang="ts">
import SancareGraphic from '@/stats/SancareGraphic.vue'
interface BaseStat {
  label: string
  unit: '%' | 'séjour(s)'
}
import VolumeGraphics from '@/stats/VolumeGraphics.vue'

import Graphic from './SancareGraphic.vue'
export interface VolumeGraphicsProps {
  labelSets: string[]
  stats: Record<string, number>[]
  statsPercent: Record<string, number>[]
  prctInfos: Record<string, BaseStat>
  statsInfos: Record<string, BaseStat>
}

const props = defineProps<VolumeGraphicsProps>()

</script>

<template>
  <div class="volume-graphics">
    <div class="stat-content row justify-content-around">
      <div class="col-5 row align-items-stretch g-0">
        <h2 class="stat-graph-title text-start">
          Proportion
        </h2>
        <SancareGraphic
          :label-sets="labelSets"
          :serie="statsPercent"
          :serie-infos="prctInfos"
          :min-y="0.0"
          :max-y="100.0"
          :label-y="'%'"
          type="line"
          class="col-12"
        />
      </div>
      <div class="col-5 row align-items-stretch g-0">
        <h2 class="stat-graph-title text-start">
          Volume
        </h2>
        <SancareGraphic
          :label-sets="labelSets"
          :serie="stats"
          :serie-infos="statsInfos"
          :min-y="0"
          :step-y="10"
          :label-y="'Séjours'"
          type="bar"
          class="col-12"
        />
      </div>
    </div>
  </div>
</template>
